"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultStackOrderManager = void 0;
/**
 * A default implementation to track stackOrder generally used as the value of
 * a StackOrderContextProvider
 */
const createDefaultStackOrderManager = () => {
  let containerStack = [];
  // Start at 1 to avoid falsy 0 checks.
  let counter = 1;
  const onChangeCallbacks = new Map();
  const isActiveItem = stackItemId => {
    if (!containerStack.length) {
      return false;
    } else {
      const topElementId = containerStack[0];
      return Boolean(topElementId) && topElementId === stackItemId;
    }
  };
  const notifyAll = () => {
    for (const stackItemId of containerStack) {
      const subscriptionCallback = onChangeCallbacks.get(stackItemId);
      if (subscriptionCallback) {
        subscriptionCallback({
          isActiveItem: isActiveItem(stackItemId)
        });
      }
    }
  };
  return {
    addToStack: onChangeArgs => {
      const newId = counter++;
      containerStack = [newId, ...containerStack];

      // Notify all items in the stack that the stack has changed in order from the
      // bottom-most elements up.
      notifyAll();
      if (onChangeArgs) {
        onChangeCallbacks.set(newId, onChangeArgs.onStackChange);
      }
      return {
        isActiveItem: () => isActiveItem(newId),
        remove: () => {
          containerStack = containerStack.filter(id => id !== newId);

          // Notify the item being removed that it is no longer the top-most item.
          const subscriptionCallback = onChangeCallbacks.get(newId);
          subscriptionCallback?.({
            isActiveItem: false
          });
          onChangeCallbacks.delete(newId);

          // Notify all items in the stack (except the one being removed) that the stack
          // has changed in order from the top-most elements down.
          notifyAll();
        }
      };
    }
  };
};
exports.createDefaultStackOrderManager = createDefaultStackOrderManager;
//# sourceMappingURL=StackOrderManagerDefaultImpl.js.map